import Vue from 'vue'
import App from './App.vue'
import '@/assets/css/common.css'

import scrollInView from './plugin.js'
import VueMarquee from 'vue-marquee-component'
Vue.use(scrollInView)
Vue.use(VueMarquee)

new Vue({
  render: h => h(App)
}).$mount('#app')
